import { Link } from 'react-router-dom';
import { episodes } from '@/mocks/episodes';
import EpisodeCard from '@/components/feature/EpisodeCard';
import SectionHeading from '@/components/base/SectionHeading';

export default function EpisodeSpotlight() {
  const latest = [...episodes].sort((a, b) => b.number - a.number).slice(0, 6);

  return (
    <section>
      <SectionHeading
        title="剧集速览"
        subtitle="最新更新的剧集章节，点击卡片查看剧情详情"
        icon="ri-play-list-2-line"
        moreTo="/episodes"
        moreLabel="全部剧集"
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 md:gap-5">
        {latest.map((episode) => (
          <EpisodeCard key={episode.id} episode={episode} />
        ))}
      </div>
      <Link
        to="/episodes"
        className="mt-5 flex items-center justify-center gap-1.5 w-full py-3 rounded-lg border border-background-300 text-sm text-foreground-700 hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer"
      >
        浏览全部 12 集剧情
        <i className="ri-arrow-right-line"></i>
      </Link>
    </section>
  );
}